import { useQueryClient } from '@tanstack/react-query';

import { TRequestOptions } from '@/shared/api';
import {
  getNotifications,
  getNotificationsUnread,
  IGetNotificationsParamsDTO,
  INotificationResponse,
  IUnreadCountResponse,
} from '@/shared/api/notifications';

export const NOTIFICATIONS_QUERY_KEY = 'notifications';

export const notificationsListQuery = (
  params?: IGetNotificationsParamsDTO,
  options?: TRequestOptions
) => ({
  queryKey: [NOTIFICATIONS_QUERY_KEY, 'list'],
  queryFn: (): Promise<INotificationResponse[]> =>
    getNotifications(params, options).then((r) => r),
});

export const unreadNotificationsCountQuery = () => ({
  queryKey: [NOTIFICATIONS_QUERY_KEY, 'unreadCount'],
  queryFn: (): Promise<IUnreadCountResponse> =>
    getNotificationsUnread().then((r) => r),
});

export const useInvalidateNotificationsList = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [NOTIFICATIONS_QUERY_KEY, 'list'],
    });
};

export const useInvalidateUnreadNotification = () => {
  const queryClient = useQueryClient();
  // Инвалидируем запрос с количеством непрочитанных уведомлений
  return () =>
    queryClient.invalidateQueries({
      queryKey: [NOTIFICATIONS_QUERY_KEY, 'unreadCount'],
    });
};
